import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from "react-router-dom"
import { Provider } from "react-redux"

import store from "./datastore"
import App from './App'
import reportWebVitals from './reportWebVitals'

import "bootstrap/dist/css/bootstrap.css"
import "react-toggle/style.css"
import "./assets/Theme.css"
import "./assets/Styles.css"
import "./assets/fa/css/all.min.css"

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
